import { render, staticRenderFns } from "./UpcomingPopulation.vue?vue&type=template&id=45c0a44e&"
import script from "./UpcomingPopulation.vue?vue&type=script&lang=js&"
export * from "./UpcomingPopulation.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingPopulation.vue?vue&type=style&index=0&id=45c0a44e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports